<section class="full-page-width-limiter">
  <h1>{{ text() }}</h1>

  @if (description) {
    <span>{{ description }}</span>
  }
  @if (!description) {
    <span><ng-content></ng-content></span>
  }
</section>
